












import {
  defineComponent,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';

const Video = defineComponent({
  props: {
    stream: {},
  },
  setup(props) {
    const videoRef = ref(null);

    function initializeStream() {
      if (props.stream && videoRef.value) {
        (videoRef.value as any).srcObject = props.stream;
      }
    }

    watch(() => props.stream, () => {
      if (videoRef.value) {
        initializeStream();
      }
    });
    // watch(() => videoRef.value, () => {
    //   initializeStream();
    // });

    onMounted(() => {
      console.log('mounted');
      initializeStream();
    });

    return {
      videoRef,
    };
  },
});

export default Video;
